import { amber } from '@mui/material/colors';

export const MAX_CHARS = 1000;

export const reviewModalNotesStyles = {
	root: {
		display: 'flex',
		flexDirection: 'column',
		backgroundColor: amber[50],
		borderRadius: 1,
		p: 2,
		width: '100%',
		gap: 0,
		position: 'relative',
		cursor: 'text'
	},

	header: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between'
	},

	notesLabel: {
		fontWeight: 600,
		fontSize: '0.875rem',
		color: 'text.primary'
	},

	notesText: {
		fontSize: '0.875rem',
		transition: 'height 200ms ease, min-height 200ms ease'
	},

	notesTextCollapsed: {
		overflow: 'hidden !important',
		scrollbarWidth: 'none',
		'&::-webkit-scrollbar': {
			display: 'none'
		}
	},

	fieldWrapper: {
		position: 'relative',
		width: '100%'
	},

	fadeOverlay: {
		position: 'absolute',
		left: 0,
		right: 0,
		bottom: 0,
		height: '1.4em',
		pointerEvents: 'none',
		background: `linear-gradient(to bottom, rgba(255, 248, 225, 0) 0%, ${amber[50]} 100%)`
	},

	limitLabelContainer: {
		display: 'flex',
		justifyContent: 'flex-end'
	},

	limitLabel: (currentLength: number) => ({
		color: currentLength >= MAX_CHARS ? 'error.main' : 'text.secondary',
		fontWeight: currentLength >= MAX_CHARS ? 600 : 400
	})
};
